import { render, staticRenderFns } from "./DevAuthor.vue?vue&type=template&id=7e2d2063&scoped=true&"
import script from "./DevAuthor.vue?vue&type=script&lang=js&"
export * from "./DevAuthor.vue?vue&type=script&lang=js&"
import style0 from "./DevAuthor.vue?vue&type=style&index=0&id=7e2d2063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2d2063",
  null
  
)

export default component.exports